<template>
  <div
    :class="{
      'input-group': hasIcon,
      'input-group-focus': focused
    }"
    class="form-group">
    <slot name="label">
      <label
        v-if="label"
        class="control-label">
        {{ label }}
      </label>
    </slot>
    <slot name="addonLeft">
      <span
        v-if="addonLeftIcon"
        class="input-group-prepend">
        <div class="input-group-text">
          <i :class="addonLeftIcon"/>
        </div>
      </span>
    </slot>
    <slot>
      <input
        :value="value"
        v-bind="$attrs"
        class="form-control"
        aria-describedby="addon-right addon-left"
        v-on="listeners">
    </slot>
    <slot name="addonRight">
      <span
        v-if="addonRightIcon"
        class="input-group-append">
        <div class="input-group-text">
          <i :class="addonRightIcon"/>
        </div>
      </span>
    </slot>
    <slot name="helperText"/>
  </div>
</template>
<script>
export default {
  name: 'BaseInput',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      description: 'Input label'
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right'
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left'
    }
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    hasIcon () {
      const { addonRight, addonLeft } = this.$slots
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
    },
    listeners () {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      }
    }
  },
  methods: {
    onInput (evt) {
      this.$emit('input', evt.target.value)
    },
    onFocus () {
      this.focused = true
    },
    onBlur () {
      this.focused = false
    }
  }
}
</script>
<style>

</style>
